import { isUSAddress } from '@apps/registry/common/utils/shippingAddressValidations';
import { CheckoutFailureCode } from '@apps/registry/common/components/ShoppingCart/utils/constants';
import type { ShippingAddressInput } from '@graphql/generated-base';

export const isCountryBlockedPurchase = ({
  isOutOfStock,
  checkoutFailureCode,
  shippingAddress,
}: {
  isOutOfStock: boolean;
  checkoutFailureCode?: CheckoutFailureCode | null;
  shippingAddress?: Pick<ShippingAddressInput, 'country' | 'countryCode'> | null;
}): boolean => {
  if (isOutOfStock) {
    return false;
  }
  // both halves are needed. BAD_ADDRESS alone also covers a malformed US address,
  //   so it would put the country copy in front of a US couple with a missing
  //   postal code. a non-US address alone would claim the country is the reason
  //   for any other failure, inventory or sponsorship included.
  if (checkoutFailureCode !== CheckoutFailureCode.BAD_ADDRESS) {
    return false;
  }
  if (!shippingAddress) {
    return false;
  }
  return !isUSAddress(shippingAddress);
};
